import React from 'react'
import { Feature } from 'geojson'
import { colors } from '~/design'
import { extraPropertiesFormatterMap } from './constants'

/**
 * Componente que lista as propriedades de um ponto de interesse (interestPoint) de uma featureCollection.
 * @returns Componente listando as propriedades formatadas.
 */
export function EntityPropertyList({
  feature,
  propertyList,
}: {
  /**Feature que se deseja listar suas informações */
  feature: Feature
  /**Array de propriedades que se deseja listar (Todas elas precisam estar no mapeamento de formatações `extraPropertiesFormatterMap`) */
  propertyList: (keyof typeof extraPropertiesFormatterMap)[]
}) {
  return (
    <div style={{ minWidth: '50%', overflow: 'hidden', textOverflow: 'clip' }}>
      {propertyList.map((property, index) => (
        <React.Fragment key={index}>
          <h4
            style={{
              color: colors.sebraeBlue,
              marginBottom: '0',
              marginTop: '7px',
              fontWeight: '500',
            }}
          >
            <b>{extraPropertiesFormatterMap[property].label}</b>
          </h4>
          <p style={{ margin: '0 0 3px 0' }}>
            {extraPropertiesFormatterMap[property].format(feature.properties?.[property])}
          </p>
        </React.Fragment>
      ))}
    </div>
  )
}
